export const companyName = (oldName, date, _type = null) => {
  const invoiceDate = new Date(date).setHours(0, 0, 0, 0)
  const cutoffDate = new Date("2026-02-01").setHours(0, 0, 0, 0)

  if (_type === "gst") {
    return invoiceDate < cutoffDate ? oldName : "27AAMCD0852A1ZZ"
  }

  return invoiceDate < cutoffDate
    ? oldName
    : "DG DIGITAL DENTAL LAB (OPC) PRIVATE LIMITED"
}

export const bankDetails = date => {
  const invoiceDate = new Date(date).setHours(0, 0, 0, 0)
  const cutoffDate = new Date("2026-02-01").setHours(0, 0, 0, 0)

  return invoiceDate < cutoffDate
    ? `
      <p class="pt-12"><b>1. AXIS BANK MIDC ANDHERI Branch</b></p>
      <p class="pt-12">RTGS/NEFT IFSC Code: <b>UTIB0000395</b></p>
      <p class="pt-12">C/A no. <b>920020055817311</b></p>
      <br />
      <p class="pt-12"><b>2. HDFC BANK</b></p>
      <p class="pt-12">RTGS/NEFT IFSC Code: <b>HDFC0000019</b></p>
      <p class="pt-12">C/A no. <b>99900609196713</b></p>
    `
    : `
      <p class="pt-12"><b>1. HDFC BANK JOGESHWARI EAST BRANCH</b></p>
      <p class="pt-12">RTGS/NEFT IFSC Code: <b>HDFC0001019</b></p>
      <p class="pt-12">C/A no. <b>50200117742931</b></p>
    `
}
